import {IntermediatePart} from "../../intermediatePart";
import {createParentPositions, ShowerHeadTypes} from "../../constants";

export default class ShowerHeadBundle extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_head_bundle';
    this.partName = 'Shower Head Bundle';
    this.translateId = "visualizer.bathroom.shower.shower_head_bundle";
    this.canBeDisabled = true;
    this.layerPriority = 12;
    if (isChild) {
      createParentPositions(this);
    }
  }

  handleClick() {
    const showerParent = this.getParent().getParent();
    showerParent.setShowerHeadType(ShowerHeadTypes.shower_head_bundle);
    if (showerParent.showerFixture && showerParent.showerFixture.activeFeature && showerParent.showerFixture.activeFeature.metaData["MountType"]
      && !showerParent.showerFixture.activeFeature.metaData["MountType"].includes("0") && !showerParent.showerFixture.disabled) {
      // store.dispatch(setLookOverlayOpened(LOOK_OVERLAYS.notCompatiblePopup));
      // return;
      this.applyFeatureIfNotCompatible();
    }
    super.handleClick();
  }

  applyFeatureIfNotCompatible() {
    const showerParent = this.getParent().getParent();
    if (showerParent.showerFixture) {
      showerParent.showerFixture.disabled = true;
    }
    showerParent.shower_head_type = ShowerHeadTypes.shower_head_bundle;
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_head_bundle && this.activeFeature
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const showerParent = this.getParent();
    const showerSize = showerParent.showerSize();
    if (showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      });
    }
    // if (showerParent.showerHead && showerParent.showerHead.activeFeature && showerParent.showerHead.activeFeature.metaData["MountType"]) {
    //   conditions.push({
    //     propName: "MountType",
    //     propValue: showerParent.showerHead.activeFeature.metaData["MountType"][0]
    //   })
    // }
    return conditions;
  }

  canDisplayDemoPoint() {
    return this.getParent().shower_head_type === ShowerHeadTypes.shower_head_bundle
  }

  showLayerPositionsModal() {
    return true
  }

}
